<!-- TODO: change the architecture to recive scope insted of tabs prop-->
<template>
  <div
    :id="componentId"
    class="al-tabs"
    :class="[
      { 'al-tabs-responsive': !notResponsive },
      { 'is-fill': isFill },
      { secoundary: variation === 'secoundary' }
    ]"
    test-id="al-tabs"
  >
    <div class="al-tabs-list" :class="[{ 'is-small': isSmall }]">
      <template v-for="(tab, index) in tabs">
        <div
          v-if="canShowTab(tab)"
          :id="'tab-' + tab.id"
          :key="'tab-' + index"
          class="al-tab"
          test-id="tab"
          :class="[{ active: index === tabActive || tab.active }, { 'is-disabled': tab.disabled }]"
        >
          <a
            :ref="'tab-' + index"
            class="al-tab-wrapper"
            test-id="tabWrapper"
            :data-text="tab.label"
            @click="!tab.disabled ? onTabClicked(index) : null"
          >
            <template v-if="tab.icon">
              <span class="al-icon" :class="'al-icon-' + tab.icon" />
            </template>
            <span class="al-tab-text">{{ tab.label }}</span>
          </a>
          <template v-if="tab.tooltip && tab.id && tab.disabled">
            <al-tooltip
              :key="'tooltip-' + tab.id"
              :target="'tab-' + tab.id"
              :label="tab.tooltip"
              placement="top"
            />
          </template>
        </div>
      </template>
      <div
        v-if="cursor"
        class="al-tabs-cursor"
        :style="'left:' + cursor.left + 'px; width:' + cursor.width + 'px'"
      />
    </div>

    <div class="al-tabs-content">
      <template v-for="(tab, index) in tabs">
        <div
          v-show="index === tabActive"
          :key="'tab-' + index"
          test-id="tabContent"
          class="al-tab-content"
        >
          <slot :name="'content-' + getNameTab(tab)" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import AlTooltip from '../tooltip/AlTooltip.vue';
/**
 * Playvox button with a past definition
 *
 * @displayName al-tabs
 */
export default {
  name: 'AlTabs',
  components: {
    AlTooltip
  },
  props: {
    id: {
      type: String,
      default: null
    },
    defaultTab: {
      type: Number,
      default: null
    },
    tabs: {
      type: Array,
      default: () => []
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    notResponsive: {
      type: Boolean,
      default: true
    },
    isFill: {
      type: Boolean,
      default: false
    },
    variation: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tabActive: null,
      cursor: null
    };
  },
  computed: {
    componentId() {
      // eslint-disable-next-line no-underscore-dangle
      const id = this.id || this._uid;
      return `tabs-${id}`;
    }
  },
  beforeCreate() {},
  created() {
    this.tabActive = this.checkRouteActive();
  },
  mounted() {
    setTimeout(() => {
      if (this.canShowTab(this.tabs[this.tabActive])) {
        this.setTabActive(this.tabActive);
        return;
      }
      this.$nuxt.error({ statusCode: 403 });
    }, 300);
  },
  methods: {
    onTabClicked(index) {
      this.setTabActive(index);
      const tab = this.tabs[this.tabActive].to
        ? this.tabs[this.tabActive].to
        : this.tabs[this.tabActive];
      this.$emit('to', tab);
    },
    setTabActive(index) {
      this.tabActive = index;
      if (this.tabActive === null) {
        this.disactiveAllTabs();
        return;
      }

      this.disactiveAllTabs();
      this.tabs[this.tabActive].active = true;

      this.setTabCursor(this.tabActive);
      this.$emit('tab-active', this.tabs[this.tabActive]);
    },
    disactiveAllTabs() {
      Object.keys(this.tabs).forEach((key) => {
        const tab = this.tabs[key];
        tab.active = false;
      });
    },
    setTabCursor(tabActive) {
      const tab = this.$refs[`tab-${tabActive}`][0];
      this.cursor = {
        width: tab.offsetWidth,
        left: tab.offsetLeft
      };
      this.incremental += 1;
    },
    getNameTab(tab) {
      let name = '';
      if (tab.name) {
        name = tab.name;
      } else {
        name = tab.label.toLowerCase();
      }
      return name;
    },
    checkRouteActive() {
      const tabIndex = this.getIndexOfActiveTab();
      return tabIndex === -1 ? null : tabIndex;
    },
    getIndexOfActiveTab() {
      const routes = this.getMatchedRoutes();
      let index = routes.length;
      let tabIndex = 0;
      do {
        index -= 1;
        tabIndex = this.findIndexTabWithAttrEqualTo('to', routes[index]);
      } while (index > 0 && tabIndex === -1);
      return tabIndex;
    },
    getMatchedRoutes() {
      return this.$route && this.$route.matched
        ? this.$route.matched.map((path) => this.getPathWithParamsAsStr(path.path))
        : [];
    },
    getPathWithParamsAsStr(path) {
      const { params } = this.$route;
      return params ? this.replaceParamsIds(path, params) : path;
    },
    replaceParamsIds(path, params) {
      let res = path;
      Object.keys(params).forEach((key) => {
        res = res.replace(`:${key}?`, params[key]);
      });
      return res;
    },
    findIndexTabWithAttrEqualTo(atribute, str) {
      return this.tabs.findIndex((tab) => {
        const isLinkedTab = tab[atribute] === str || tab.base === str;
        return tab.to ? isLinkedTab : -1;
      });
    },
    canShowTab(tab) {
      return !tab || tab.visible || tab.visible === undefined;
    }
  }
};
</script>

<style lang="scss">
/**
 * Variables
 */
$color-active: #12b981;

$font-color: #68706f;
$font-color-active: #009865;
$font-size: 16px;
$font-size-small: 12.8px;
$p-content: 28px;
$transition: 0.3s;

/**
* Styles for tabs
*/
.al-tabs {
  &.is-fill {
    .al-tab {
      flex: 1;
      text-align: center;
    }
  }

  .al-tabs-list {
    border-bottom: 1px solid #d9e3e2;
    display: flex;
    height: 100%;
    list-style: none;
    padding: 0 ($p-content / 2);
    position: relative;

    .al-tab {
      align-items: center;
      cursor: pointer;
      display: flex;
      padding: 0 ($p-content / 2);

      .al-tab-wrapper {
        color: $font-color;
        display: block;
        font-size: $font-size;
        font-weight: bold;
        padding: ($p-content / 2) 0;
        transition: $transition;
      }

      &.active {
        .al-tab-wrapper {
          color: $font-color-active;
        }
      }

      &.is-disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }
    }

    &.is-small {
      .al-tab {
        .al-tab-wrapper {
          font-size: $font-size-small;
          text-transform: uppercase;
        }
      }
    }
  }

  .al-tabs-cursor {
    border-bottom: 2px solid $color-active;
    bottom: -1px;
    left: 0;
    position: absolute;
    transition: $transition ease-in-out;
    width: 0%;
  }

  &.secoundary {
    .al-tabs-list {
      .al-tab {
        .al-tab-wrapper {
          color: color(black, lighten, 3);
          font-size: 12.8px;
        }

        &.active .al-tab-wrapper {
          color: color(green, darken, 1);
        }
      }
    }

    .al-tabs-cursor {
      display: none;
    }
  }
}
</style>
